import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VModal from 'vue-js-modal'
import {BootstrapVue, BIconArrowUp} from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { faPlus, faMinus, faMapMarker, faClock, faGraduationCap, faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueJamIcons from 'vue-jam-icons'


library.add(faUserSecret, faPlus, faMinus, faMapMarker, faClock, faGraduationCap, faEnvelope, faPhone)
Vue.component('font-awesome-icon', FontAwesomeIcon)

// PurgeCSS'd bootstrap files
import '../src/assets/bootstrap/css/extra-bootstrap-automodule.css'
import '../src/assets/bootstrap/css/bootstrap-vue.css'

// Full bootstrap files
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(VModal)
Vue.use(VueJamIcons)
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
 